import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=70e59bc4&"
import script from "./Process.vue?vue&type=script&lang=js&"
export * from "./Process.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports